import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Css/componentas/Button.css'
import './Css/componentas/alert.css';
import './Css/componentas/Loding.css';
import 'react-loading-skeleton/dist/skeleton.css';


import './pages/Auth/outhoperation/Auth.css';
import App from './App';
import './Css/componentas/google.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Custom.css';

import { BrowserRouter as Router } from 'react-router-dom';
import { MenuProvider } from './Context/MenuContext';
import { WindowProvider } from './Context/WindowContext';
import CartContext, { CartChangercontext } from './Context/CartChangerContext';



const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
  <React.StrictMode>
    <WindowProvider>


      <MenuProvider>

        <CartChangercontext>
          <Router>

            <App />
          </Router>
        </CartChangercontext>

      </MenuProvider>
    </WindowProvider>

  </React.StrictMode>
);
